import { Component, DoCheck, Input, ElementRef, ContentChild } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  template: '<ng-content></ng-content>',
  selector: 'pui-nav-item'
})
export class PuiNavItemComponent implements DoCheck {
  @Input() name: string;
  @Input() routerLink: RouterLink;
  @Input() queryParams: {[k: string]: any};
  @Input() fragment: string;
  @ContentChild(RouterLink) link: RouterLink;

  constructor(private el: ElementRef) {}

  ngDoCheck() {
    if (!this.name) {
      this.name = this.el.nativeElement.innerHTML;
    }
  }
}
